<template>
  <widget-template-gallery
    api_endpoint="POST: /api/v1/order-confirmation/template-types"
    ref="gallery"
    :build_api_params="buildApiParams"
    templates_response_key="template_types"
    :excluded_template_ids="['stub']"
    :selected_template_id="selected_template_id"
    :single_column="single_column"
    :watch_props="['theme', 'background_image_url', 'side_image_url', 'logo_url', 'use_logo']"
    @template-selected="onTemplateSelect"
    @template-deselected="$emit('template-deselected')"
    @templates-loaded="$emit('templates-loaded', $event)"
  >
    <template #template-card="{ template, is_selected, on_select, comp_custom_fonts }">
      <m-order-confirmation-template-card
        :template="template"
        :theme="theme"
        :organization_name="organization_name"
        :is_selected="is_selected"
        :background_image_url="background_image_url"
        :side_image_url="side_image_url"
        :logo_url="logo_url"
        :use_logo="use_logo"
        :order_confirmation_settings="order_confirmation_settings"
        :comp_custom_fonts="comp_custom_fonts"
        @select="on_select"
      />
    </template>
  </widget-template-gallery>
</template>

<script>
import WidgetTemplateGallery from '@/components/widget/widget-template-gallery.vue';
import mOrderConfirmationTemplateCard from './m-order-confirmation-template-card.vue';

/**
 * Order Confirmation Template Gallery
 *
 * Thin wrapper around generic widget-template-gallery.
 * Provides order-confirmation-specific API configuration and template card rendering.
 */
export default {
  name: 'mOrderConfirmationTemplateGallery',

  components: {
    WidgetTemplateGallery,
    mOrderConfirmationTemplateCard,
  },

  props: {
    selected_template_id: {
      type: String,
      default: null,
    },

    theme: {
      type: Object,
      default: () => ({}),
    },

    organization_name: {
      type: String,
      default: 'Your Organization',
    },

    background_image_url: {
      type: String,
      default: null,
    },

    side_image_url: {
      type: String,
      default: null,
    },

    logo_url: {
      type: String,
      default: null,
    },

    use_logo: {
      type: Boolean,
      default: false,
    },

    order_confirmation_settings: {
      type: Object,
      default: () => ({}),
    },

    single_column: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    theme: {
      handler: 'reloadGallery',
      deep: true,
    },

    background_image_url: 'reloadGallery',
    side_image_url: 'reloadGallery',
    logo_url: 'reloadGallery',
    use_logo: 'reloadGallery',
  },
  methods: {
    reloadGallery() {
      if (this.$refs.gallery) {
        this.$refs.gallery.reload();
      }
    },
    buildApiParams(gallery_context) {
      return {
        organization_id: gallery_context.$route.params.organization_id,
        internal_label:'',
        theme: {
          primary_color: this.theme?.colors?.primary?.value,
          secondary_color: this.theme?.colors?.secondary?.value,
          font_family: this.theme?.font_family,
        },
        images: {
          page_background_url: this.background_image_url,
          side_image_url: this.side_image_url,
          use_logo: this.use_logo,
          logo_image_url: this.use_logo ? this.logo_url : null,
        },
        template_request_type: 'preview',
      };
    },

    onTemplateSelect(template) {
      this.$emit('template-selected', template);
    },
  },
};
</script>

<style scoped lang="scss"></style>